module.exports = __webpack_public_path__ + "img/Slider-EDI.bda2ec71.png";